<div class="row pt-2 pb-2">
    <div class="col-sm-9">
        <h4 class="page-title">Add IoT Device Detail</h4>
    </div>
    <div class="col-sm-3">
        <div class="btn-group float-sm-right">
            <button type="button" (click)="ClearForm()" data-toggle="modal" data-target="#device_modal" class="btn btn-outline add_btn btn-sm">
                <i class="zmdi zmdi-plus mr-1"></i>Add Device
            </button>
        </div>
    </div>
</div>

<div class="row">
    <div class="col-lg-12">
        <div class="card">
            <div class="card-body">
                <!-- <h5 class="card-title">Responsive Table</h5> -->
                <div class="table-responsive">
                    <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" class="table table-bordered table-striped table-hover">
                        <thead>
                            <tr>
                                <th>Sr. No.</th>
                                <th>Device ID</th>
                                <th style="white-space: normal;">Description</th>
                                <th>Model No.</th>
                                <th>Mfg. Date</th>
                                <!-- <th>Assigned Status</th> -->
                                <th>Version</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            
                            <tr *ngFor="let dData of deviceRowdata; let i = index">
                                <td>{{i+1}}</td>
                                <td>{{dData.device_id}}</td>
                                <td>{{dData.description}}</td>
                                <td>{{dData.model_no}}</td>
                                <td>{{dData.manufacturing_date | date:'dd-MM-yyyy'}}</td>
                                <!-- <td>{{dData.assigned_status}}</td> -->
                                <td>{{dData.version}}</td>
                                <td style="text-align: center;">
                                    <a data-toggle="modal" data-target="#device_modal" (click)="EditDevice(dData.device_id)" style="color: dodgerblue">
                                        <i class="fa fa-pencil fa-lg" aria-hidden="true"></i>
                                    </a><span style="margin-left: 15px;"></span>
                                    <a (click)="DeleteDevice(dData.device_id)" style="color: red;">
                                        <i class="fa fa-trash fa-lg" aria-hidden="true"></i>
                                    </a>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    
                </div>
            </div>
        </div>
    </div>
</div>
<div class="loader-wrapper" id="loading" *ngIf="isLoading" >
    <div class="loader-card">
        <div class="spinner">
            <div class="spinner-ring"></div>
            <div class="spinner-ring delay"></div>
            <div class="core"></div>
        </div>
    </div>
</div>
<div id="device_modal" class="modal fade hide" role="dialog">
    <form action="#" #deviceMasterForm="ngForm">
        <div class="modal-dialog modal-lg">
            <div class="modal-content">
                <div class="modal-header">
                    <h6 class="modal-title">Device Details</h6>
                    <button type="button" class="close" data-dismiss="modal">&times;</button>
                </div>
                <div class="modal-body">
                    <div class="form-row">
                        <input type="hidden" id="devId" name="devId" [(ngModel)]="deviceForm.devId">

                        <div class="form-group col-12 col-md-4">
                            <label for="device_id">Device ID</label>
                            <input type="text" id="device_id" name="device_id" [(ngModel)]="deviceForm.device_id"
                                class="form-control form-control-sm"  required>
                        </div>
    
                        <div class="form-group col-12 col-md-4">
                            <label for="description">Description</label>
                            <input type="text" id="description" name="description" [(ngModel)]="deviceForm.description"
                                class="form-control form-control-sm" required>
                        </div>
    
                        <div class="form-group col-12 col-md-4">
                            <label for="model_no">Model No.</label>
                            <input type="text" id="model_no" name="model_no" [(ngModel)]="deviceForm.model_no"
                                class="form-control form-control-sm" required>
                        </div>
    
                        <div class="form-group col-12 col-md-4">
                            <label for="manufacturing_date">Manufacturing Date</label>
                            <input type="date" id="manufacturing_date" name="manufacturing_date"
                                [(ngModel)]="deviceForm.manufacturing_date" class="form-control form-control-sm" required>
                        </div>
    
                        <div class="form-group col-12 col-md-4">
                            <label for="version">Version</label>
                            <input type="text" id="version" name="version" [(ngModel)]="deviceForm.version"
                                class="form-control form-control-sm" required>
                        </div>
    
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="reset" class="btn btn-danger" data-dismiss="modal">Cancel</button>
                    <button type="submit" class="btn btn-primary" (click)="onSubmit()">
                        {{ isEditMode ? 'Update' : 'Save' }}</button>
                </div>
            </div>
        </div>
    </form>
</div>